var _circle, _circle2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFromTo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 33,
    viewBox: "0 0 10 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4,
    stroke: "#595959",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 28.4,
    r: 4,
    fill: "#FFD249"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.73096 10.775C4.73096 11.0511 4.95481 11.275 5.23096 11.275C5.5071 11.275 5.73096 11.0511 5.73096 10.775H4.73096ZM5.73096 13.325C5.73096 13.0489 5.5071 12.825 5.23096 12.825C4.95481 12.825 4.73096 13.0489 4.73096 13.325H5.73096ZM4.73096 15.875C4.73096 16.1511 4.95481 16.375 5.23096 16.375C5.5071 16.375 5.73096 16.1511 5.73096 15.875H4.73096ZM5.73096 18.425C5.73096 18.1489 5.5071 17.925 5.23096 17.925C4.95481 17.925 4.73096 18.1489 4.73096 18.425H5.73096ZM4.73096 20.975C4.73096 21.2511 4.95481 21.475 5.23096 21.475C5.5071 21.475 5.73096 21.2511 5.73096 20.975H4.73096ZM5.73096 23.525C5.73096 23.2489 5.5071 23.025 5.23096 23.025C4.95481 23.025 4.73096 23.2489 4.73096 23.525H5.73096ZM4.73096 9.5V10.775H5.73096V9.5H4.73096ZM4.73096 13.325V15.875H5.73096V13.325H4.73096ZM4.73096 18.425V20.975H5.73096V18.425H4.73096ZM4.73096 23.525V24.8H5.73096V23.525H4.73096Z",
    fill: "#595959"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFromTo);
export default __webpack_public_path__ + "static/media/from-to.efdba372dcae67e1e4655633f999f75f.svg";
export { ForwardRef as ReactComponent };